import { Model } from "@/atoms/model";
import { SearchModelFormModel } from "@/components/SearchModelView/search-model-form-model";

type ModelKeywords = SearchModelFormModel["model"];

export function searchModels(modelKeywords: ModelKeywords, totalModels: Model[]): Model[] {
  const { modelName: modelNameKeyword, modelCode: modelCodeKeyword } = modelKeywords;

  const isNonEmptyKeywords = Boolean(modelNameKeyword && modelCodeKeyword);

  const result = totalModels.filter((model) => {
    const isNameMatched = isModelNameMatched(model.name, modelNameKeyword);
    const isCodeMatched = isModelCodeMatched(model.code, modelCodeKeyword);
    if (isNonEmptyKeywords) return isCodeMatched && isNameMatched; // NOTE: 両方入力がある場合はand条件
    if (!isNonEmptyKeywords) return isCodeMatched || isNameMatched; // NOTE: 片方だけ入力がある場合はor条件
  });

  // NOTE: MAX 1000件まで渡す
  return result.slice(0, 1000);
}

/*
 * NOTE: matched 条件
 * 1. 部分一致
 * 2. 英語の場合は大・小文字の区別をしない
 * 3. 英語の場合は全角・半角の区別をしない
 * 4. wildcard pattern matchingをする
 * ex1 ) Input: keyword% output: keywordaaa
 * ex2 ) input: keyword%-200 output: keywordaaa-200
 * ex3 ) input: keyword%% は "ex1"と同じ
 * ex4 ) input: %keyword output: aaakeyword
 */
export function isModelNameMatched(modelName: string, keyword?: string): boolean {
  if (!keyword) return false;

  const halfWidthNameLowerCase = convertFullWidthTextToHalfWidthText(modelName.toLocaleLowerCase("en-US"));
  const halfWidthKeywordLowerCase = convertFullWidthTextToHalfWidthText(keyword.toLocaleLowerCase("en-US"));

  // NOTE: 「％」の対応
  if (halfWidthKeywordLowerCase.includes("%")) {
    const regexPattern = `^${halfWidthKeywordLowerCase.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&").replace(/%+/g, ".+")}$`;
    const regex = new RegExp(regexPattern);
    return regex.test(halfWidthNameLowerCase);
  }

  return halfWidthNameLowerCase.includes(halfWidthKeywordLowerCase);
}

/*
 * NOTE: matched 条件
 * 1. 完全一致
 * 2. 英語の場合は大・小文字の区別をしない
 * 3. 英語の場合は全角・半角の区別をしない
 */
export function isModelCodeMatched(modelCode: string, keyword?: string): boolean {
  if (!keyword) return false;

  const halfWidthCodeLowerCase = convertFullWidthTextToHalfWidthText(modelCode.toLocaleLowerCase("en-US"));
  const halfWidthKeywordLowerCase = convertFullWidthTextToHalfWidthText(keyword.toLocaleLowerCase("en-US"));
  return halfWidthCodeLowerCase === halfWidthKeywordLowerCase;
}

export function convertFullWidthTextToHalfWidthText(text: string): string {
  return text.replace(/[\uff01-\uff5e]/g, (char) => {
    return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
  });
}
